document.addEventListener('DOMContentLoaded', (event) => {
let brandMenu = document.querySelector("#SiteHeader > div.page-width > div > div.header-item.header-item--navigation.text-center > ul li:last-child");
brandMenu.classList.add("brandMenu");
});

document.addEventListener('DOMContentLoaded', (event) => {

//update breadcrumb title to be last child elements html
let collectionHeader = document.querySelector("h1.section-header__title");
let breadcrumb = document.querySelector('.breadcrumb');
let lastBreadcrumb = breadcrumb.lastElementChild.innerHTML;
let totalBreadcrumbs = document.querySelectorAll('.breadcrumb a');

if (totalBreadcrumbs.length > 2) {
	collectionHeader.innerHTML = lastBreadcrumb;
}

//remove collections from breadcrumb
let breadcrumbsCollection = document.querySelector('.breadcrumb a[href="/collections"]');
let breadcrumbslash = breadcrumbsCollection.previousElementSibling;
breadcrumbslash.remove();
breadcrumbsCollection.remove();

var acc = document.getElementsByClassName("collection-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

});


//open external link  in new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
document.addEventListener('DOMContentLoaded', (event) => {
	let intervalId = window.setInterval(function(){
  	if(document.getElementById("CartDrawer").classList.contains("drawer--is-open") && window.innerWidth < 960){
      document.getElementById("dummy-chat-button-iframe").style.display = "none"
    }
    else{
      document.getElementById("dummy-chat-button-iframe").style.display = "block"
    }
	}, 500);
})

// let hpBrandMenu = document.querySelector("#SiteHeader > div.page-width > div > div.header-item.header-item--navigation.text-center > ul > li:last-child");
// hpBrandMenu.classList.add("brandMenu");